import { render, staticRenderFns } from "./AllRoutes.vue?vue&type=template&id=42142a76&"
import script from "./AllRoutes.vue?vue&type=script&lang=js&"
export * from "./AllRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports